import { isEmpty } from 'lodash';

/**
 * Receives an object containing firstName and lastName properties
 * and returns full name depending on values.
 *
 * @param nameObj - data containing student first name, last name, and preferred name
 * @param showPreferredName - conditionally show the preferred name
 */
const getFullName = (nameObj, showPreferredName = true) => {
  if (isEmpty(nameObj)) {
    return '';
  }
  const { firstName, lastName, preferredName } = nameObj;
  const trimmedFirstName = firstName?.trim();
  const trimmedLastName = lastName?.trim();
  const trimmedPreferredName =
    preferredName && showPreferredName ? `"${preferredName.trim()}"` : null;
  return [trimmedFirstName, trimmedPreferredName, trimmedLastName]
    .filter(value => !!value)
    .join(' ')
    .trim();
};

export default getFullName;
